import React, {useEffect, useState} from "react";
import {Company} from "./Company";
import {useAxios} from "../../shared/technical/rest/AxiosProvider";
import {getAllCompanies} from "./CompaniesApi";
import {useAccount} from "../users/AccountProvider";
import {isCompanyAdmin} from "../users/AccountServiceRoles";
import {FormControl, FormHelperText, InputLabel, MenuItem} from "@mui/material";
import {nunitoBase} from "../../shared/technical/style/theme";
import Select from "@mui/material/Select";

export function CompanySelectField(props: {
  name: string,
  label: string,
  value: Company | undefined,
  onChange: (company: Company) => void,
  required?: boolean,
  disabled?: boolean,
}) {
  const axios = useAxios();
  const account = useAccount();

  const [companies, setCompanies] = useState<Company[]>([]);

  useEffect(() => {
    if (isCompanyAdmin(account)) {
      setCompanies([account.company!!])
    } else {
      getAllCompanies(axios).then(setCompanies);
    }
  }, [axios, account])

  if(companies.length === 0) {
    return <></>;
  }

  return (
    <FormControl fullWidth={true} variant={"standard"}>
      <InputLabel id={'select_' + props.name + '_label'}>{props.label + (props.required ? ' *' : '')}</InputLabel>
      <Select
        id={'select_' + props.name}
        labelId={'select_' + props.name + '_label'}
        label={props.label}
        name={props.name}
        onChange={event => {
          const e = event as {} as React.ChangeEvent<HTMLSelectElement>;
          if (e.target.value === '') {
            //
          } else {
            let value = companies.find((company: Company) => company.id === e.target.value);
            if (value) {
              props.onChange(value);
            }
          }
        }
        }
        value={props.value?.id || ''}
      >
        <MenuItem value={''} disabled={true} key={''}>{'---'}</MenuItem>
        {companies.map((company) =>
          <MenuItem
            id={'option_' + company.name}
            value={company.id}
            key={company.id}
            sx={{...nunitoBase,}}
          >{company.name}
          </MenuItem>)}
      </Select>
      <FormHelperText>{}</FormHelperText>
    </FormControl>
  );
}

